<template lang="pug">
  #companion-action-menu-card
    .level.is-mobile.my-dashboard-header
      .level-left.is-mobile
        .level-item.is-mobile
          WtTile(@click.native="backButton")
            .chapters-info-title
              span.back-icon-text
                WtSvgIcon(icon="companion/arrow_left" width="19px" height="19px").mt-1
                | Back
      .level-right.is-mobile
        .level-item.is-mobile.m-4
          .bookmark-icon
          //-   WtSvgIcon(
          //-     v-if="isContentSaved"
          //-     @click.native="editContentSavedStatus"
          //-     icon="companion/saved_bookmark"
          //-     width="24px"
          //-     height="24px"
          //-   )
          //-   WtSvgIcon(
          //-     v-else
          //-     @click.native="editContentSavedStatus"
          //-     icon="companion/bookmark"
          //-     width="24px"
          //-     height="24px"
          //-   )
          //- WtActionMenu.ml-3(:mobileModal="false")
          //-   .action-menu
          //-     WtActionMenuItem(
          //-       text="Edit plan"
          //-       @click.native="!isProcessing ? editPlan() : null"
          //-     )
  </template>

<script>
import WtTile from "@@/WtTile/WtTile";
import WtActionMenu from "@@/WtActionMenu/WtActionMenu";
import WtActionMenuItem from "@@/WtActionMenuItem/WtActionMenuItem";
import WtSvgIcon from "@@/WtSvgIcon/WtSvgIcon";

import { mapActions } from "vuex";

export default {
  name: "CompanionActionsMenu",

  components: {
    WtTile,
    WtActionMenu,
    WtActionMenuItem,
    WtSvgIcon
  },

  props: {
    backButton: {
      type: Function,
      default: () => {} // Empty function as default
    }
  },

  data() {
    return {
      isProcessing: false,
      isProcessed: false,
      memberId: this.$auth.user().id,
      isContentSaved: false // make it reactive when wiring with the content (fetch it from getters)
    };
  },

  computed: {
    bookmarkIcon() {
      return this.isContentSaved
        ? "companion/saved_bookmark"
        : "companion/bookmark";
    }
  },

  methods: {
    ...mapActions("members", [
      "removeFriend",
      "setRemoveFriendProcessingForMember",
      "fetchFriends"
    ]),

    async editPlan() {},

    editContentSavedStatus() {
      this.isContentSaved = !this.isContentSaved;
      // make an API call to change status
    }
  }
};
</script>

<style scoped>
#companion-action-menu-card {
  max-height: 24px;

  .my-dashboard-header {
    max-height: 24px;
  }
  .chapters-info-title {
    font-size: 14px;
    font-weight: 600;
    line-height: 18px;
    color: var(--Text-General-Primary, #1b1d20);

    .back-icon-text {
      display: flex;
      align-items: center;
      gap: 4px;
    }

    &:hover {
      cursor: pointer;
    }
  }

  .bookmark-icon {
    &:hover {
      cursor: pointer;
    }
  }
}
</style>
